import * as yup from "yup";
import { stripHtml } from "helpers";

/** Prvi korak — samo odabir grupe. */
export const NOTIFICATION_ENTITY_TYPE_SCHEMA = yup.object().shape({
  entityType: yup.number().nullable().required("Tip entiteta je obavezan"),
});

/** Drugi korak — tip notifikacije, kanali i sadržaj poruke. */
export const NOTIFICATION_MESSAGE_SETUP_SCHEMA = yup.object().shape({
  title: yup.string().required("Naziv je obavezan"),
  messageTemplate: yup.string().test(
    "not-empty-html",
    "Predložak poruke je obavezan",
    (value) => !!stripHtml(value ?? "")
  ),
  scope: yup.string().required("Opseg je obavezan"),
  channels: yup.number().min(1, "Odaberite barem jedan kanal"),
  customScheduledAt: yup.string().nullable().when("entityType", {
    is: 99,
    then: (schema) => schema.required("Datum slanja je obavezan za prilagođenu notifikaciju"),
  }),
});

export const NOTIFICATION_STEP2_ENTITY_SCHEMA = yup.object().shape({
  includedEntityIds: yup.array().min(1, "Odaberite barem jedan entitet"),
});

export const NOTIFICATION_STEP3_SCHEMA = yup.object().shape({
  includedUserIds: yup.array().min(1, "Odaberite barem jednog korisnika"),
});

export const NOTIFICATION_STEP4_SCHEMA = yup.object().shape({
  daysBeforeExpiry: yup.number().when("isCustom", {
    is: false,
    then: (schema) => schema.required("Broj dana prije isteka je obavezan").min(0, "Mora biti 0 ili više"),
    otherwise: (schema) => schema.nullable(),
  }),
  repeatIntervalDays: yup.number().nullable().when("isRepeating", {
    is: true,
    then: (schema) => schema.required("Interval ponavljanja je obavezan").min(1, "Mora biti najmanje 1 dan"),
  }),
  repeatCount: yup.number().nullable().when("isRepeating", {
    is: true,
    then: (schema) => schema.required("Broj ponavljanja je obavezan").min(1, "Mora biti najmanje 1"),
  }),
});
